import { Container } from "@material-ui/core"
import PaymentHeader from "components/PurchasePage/Preview/Payment/PaymentHeader"
import PaymentLink from "components/PurchasePage/Preview/Payment/PaymentLink"
import styled from "styled-components"

const StyledWrapper = styled(Container)`
  padding-right: 60px;
  margin-top: 80px;
  padding-left: 120px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-top: 66px;
    padding-left: 16px;
    padding-right: 16px;
  }
`

const CreditCard = () => {
  return (
    <StyledWrapper>
      <PaymentHeader
        title={"פרטי תשלום"}
        subtitle={"תשלום מאובטח באמצעות קרדיט גארד"}
      />
      <PaymentLink type="creditCard" flow="quickPurchase" />
    </StyledWrapper>
  )
}

export default CreditCard
